import Select from "components/common/Select";
import { assertArray, assertObject } from "core/validation";
import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { actions as globalActions } from "./logic/actions";
import {DATE_FORMAT_ONLY_YEAR, formatDate} from "components/common/dateUtils";


export const FilmSelectFormattedLabel = ({ label = "", company = "", ratingType = "", releaseType = "", relDate = "" }, state = {}) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", padding: "4px 10px", fontSize: 12 }}>
            <div style={{ display: "flex", flex: 1, fontSize: 14, fontWeight: 500 }}>{label}</div>
            {state.context === "menu" && (
                <div style={{ display: "flex", flex: 1 }}>
                    <React.Fragment>
                        <div style={{ display: "flex", flex: "6", opacity: 0.6 }}>{company}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{ratingType}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{releaseType}</div>
                        <div style={{ display: "flex", flex: "1", opacity: 0.6 }}>{relDate}</div>
                    </React.Fragment>
                </div>
            )}
        </div>
    );
};

FilmSelectFormattedLabel.propTypes = {
    label: PropTypes.string,
    company: PropTypes.string,
    ratingType: PropTypes.string,
    releaseType: PropTypes.string,
    relDate: PropTypes.string,
    state: PropTypes.object,
};


export const filmSelectStyle = {
    menuList: (provided) => ({
        ...provided,
        minHeight: 600,
    }),
    menu: (provided) => ({
        ...provided,
        minHeight: 600,
    }),
};

export function FilmReleaseSelect({ defaultValue, loadingStatus, filmTitles, onChange, onFetch, filmReleaseId, companyIds = [] }) {
    const loading = loadingStatus === "SEND";
    const options = filmTitles.filter(film => film.id !== filmReleaseId).map((fTitle) => ({
        value: fTitle.id,
        label: fTitle.title,
        company: fTitle.companyId.title,
        ratingType: get(fTitle, "filmRatingTypeId.abbreviation", ""),
        releaseType: get(fTitle, "filmReleaseTypeId.abbreviation", ""),
        relDate: fTitle.releaseDate
            ? formatDate(fTitle.releaseDate, DATE_FORMAT_ONLY_YEAR)
            : formatDate(fTitle.enteredDate, DATE_FORMAT_ONLY_YEAR),
        ...fTitle,
    }));
    function handleOnChange(value) {
        if (onChange) {
            if (!assertObject(value) || !assertObject(value.parentReleaseId)) {
                onChange(value);
            } else {
                const { parentReleaseId } = value;
                if (assertObject(parentReleaseId)) {
                    const filmR = {
                        ...parentReleaseId,
                        value: parentReleaseId.id,
                        label: parentReleaseId.title,
                    };
                    onChange(filmR);
                }
            }
        }
    }

    function handleInput(value) {
        if (value.length > 1) {
            handleOnFetch(value);
        }
    }
    function handleOnKeyDown(e) {
        if (e.keyCode === 13) {
            handleOnFetch(e.target.value);
        }
    }
    function handleOnFetch(titlePattern) {
        onFetch({
            titlePattern,
            companyIds,
        });
    }

    return (
        <Select
            placeholder="Type or select title"
            value={defaultValue}
            onChange={handleOnChange}
            onInput={handleInput}
            onKeyDown={handleOnKeyDown}
            defaultMenuIsOpen
            options={options}
            defaultMenuPortalTarget
            styles={assertArray(options) ? filmSelectStyle : {}}
            formatOptionLabel={FilmSelectFormattedLabel}
            loading={loading}
        />
    );
}


export default connect(
    (state) => ({
        filmTitles: state.globalApp.filmReleases,
        loadingStatus: state.globalApp.loadFilmStatus,
    }),
    (dispatch) => ({
        onFetch: (obj) => dispatch(globalActions.APP_GET_FILM_TITLE.send(obj)),
    })
)(FilmReleaseSelect);
